import { Close } from "components/icons";
import { useEffect, useRef, useState } from "react";

// custom multi select input with repeatition of values allowed

const MultiSelectWithRepeat = ({ selectedOptions, setSelectetOptions, intitialOptions, addNewValue = true }) => {
  const customSelectInput = useRef(null);
  const listRef = useRef(null);
  const [showSelectionDropdown, setShowSelectionDropdown] = useState(false);
  const [value, setValue] = useState("");
  const [filteredValues, setFilteredValues] = useState(intitialOptions);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  useEffect(() => {
    if (value.length) {
      // filter based on value and label both
      setFilteredValues(
        intitialOptions.filter(
          (option) =>
            option.label.toLowerCase().indexOf(value.toLocaleLowerCase()) !== -1 ||
            option.value.toLowerCase().indexOf(value.toLocaleLowerCase()) !== -1,
        ),
      );
    } else setFilteredValues([...intitialOptions]);
  }, [value, intitialOptions]);
  useEffect(() => {
    const newValue = filteredValues.find((val) => val.value === value);
    if (newValue !== undefined) {
      setSelectedIndex(filteredValues.indexOf(newValue));
    }
  }, [filteredValues]);
  const handleRemove = (event, index) => {
    setSelectetOptions([...selectedOptions.slice(0, index), ...selectedOptions.slice(index + 1)]);
  };

  const handleEnterKeyDown = (event) => {
    if (event.key === "Enter") {
      const newValue = filteredValues.find((val) => val.value === value);
      if (newValue !== undefined) {
        setSelectetOptions([...selectedOptions, { label: newValue.label, value: newValue.value }]);
      } else setSelectetOptions([...selectedOptions, { label: event.target.value, value: event.target.value }]);
    }
  };

  const handleSearchKeyChange = (event) => {
    setSelectedIndex(-1);
    setValue(event.target.value);
  };
  const handleSelection = (event) => {
    if (event.target.tagName === "LI") {
      setValue("");
      setSelectetOptions([...selectedOptions, filteredValues[event.target.value]]);
      customSelectInput.current.focus();
    }
  };

  useEffect(() => {
    if (listRef.current && selectedIndex > 0) {
      const listItem = listRef.current?.children[selectedIndex];
      const listItemHeight = listItem?.offsetHeight;
      listRef.current.scrollTop = listItem?.offsetTop - listItemHeight;
    }

    if (listRef.current && selectedIndex < filteredValues.length - 1) {
      const listItem = listRef.current?.children[selectedIndex];
      const listItemHeight = listItem?.offsetHeight;
      const listHeight = listRef.current?.offsetHeight;
      const scrollOffset = listItem?.offsetTop - listRef.current?.scrollTop;
      if (scrollOffset + listItemHeight > listHeight) {
        listRef.current.scrollTop = listItem?.offsetTop + listItemHeight - listHeight;
      }
    }
  }, [selectedIndex]);

  return (
    <div className="position-relative mt-3">
      {showSelectionDropdown && <div className="backdrop" onClick={() => setShowSelectionDropdown(false)}></div>}
      {showSelectionDropdown && (
        <ul
          onClick={handleSelection}
          onKeyDown={handleEnterKeyDown}
          id="listRef"
          tabIndex="0"
          className="multi-list-container"
          ref={listRef}
        >
          {filteredValues.map((option, index) => {
            return (
              <li
                key={index}
                value={index}
                onClick={handleSelection}
                className={selectedIndex === index ? "selected" : ""}
              >
                {option.label}
              </li>
            );
          })}
        </ul>
      )}
      <div className="media-live-input-tags-container form-control" trigger="click">
        <ul class="filter-tags-list">
          {selectedOptions.map((option, index) => {
            return (
              <li>
                {option.label}
                <button
                  type="button"
                  class="btn btn-filter-remove"
                  onClick={(event) => {
                    handleRemove(event, index);
                  }}
                >
                  <Close />
                </button>
              </li>
            );
          })}
        </ul>

        <input
          ref={customSelectInput}
          type="text"
          className="input-tags-container-input"
          value={value}
          onChange={handleSearchKeyChange}
          onClick={() => setShowSelectionDropdown(true)}
          placeholder={!selectedOptions.length ? "Select languages" : ""}
          onKeyDown={(event) => {
            setShowSelectionDropdown(true);
            if (filteredValues.length) {
              if (event.key === "ArrowUp") {
                event.preventDefault();
                setSelectedIndex(Math.max(selectedIndex - 1, 0));
              }
              if (event.key === "ArrowDown") {
                event.preventDefault();
                setSelectedIndex(Math.min(selectedIndex + 1, filteredValues.length - 1));
              }
              if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
                const newValue = filteredValues.find((val) => val.value === value);
                if (newValue === undefined) setSelectedIndex(-1);
              }
            }

            if (event.key === "Backspace" && !value.length) {
              setSelectetOptions([...selectedOptions.slice(0, selectedOptions.length - 1)]);
            }
            if (event.key === "Enter" && addNewValue) {
              event.preventDefault();
              if (selectedIndex !== -1) {
                setValue("");
                setSelectetOptions([...selectedOptions, filteredValues[selectedIndex]]);
              } else if (value.length) {
                setSelectetOptions([
                  ...selectedOptions,
                  { label: event.target.value.trim(), value: event.target.value.trim() },
                ]);
                setValue("");
              }

              event.target.focus();
            }
          }}
        />
      </div>
    </div>
  );
};
export default MultiSelectWithRepeat;
